import { useMemo } from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/core/select';

import { Filter, FilterDefs, FilterDef, filterValueSchemas, UnsafeFilter } from './types';

type Props = {
  filter: Filter<FilterDefs, string>;
  filterDef: FilterDef<'boolean'>;
  onChange: (filter: UnsafeFilter) => void;
};

export function DataTableBooleanInput({ filter, filterDef, onChange }: Props) {
  // Note - Internally using the strings 'true' and 'false' instead of  boolean primitives
  // because the <Select> only supports strings
  const value = useMemo<'true' | 'false' | undefined>(() => {
    const parsedValue = filterValueSchemas.boolean.safeParse(filter.value);
    if (!parsedValue.success || parsedValue.data === undefined) {
      return undefined;
    }
    return parsedValue.data ? 'true' : 'false';
  }, [filter.value]);

  return (
    <Select
      value={value}
      onValueChange={(nextValue) => {
        onChange({ ...filter, value: nextValue === 'true' });
      }}
    >
      <SelectTrigger
        aria-label={`Value for ${filterDef.label}`}
        className="h-8 rounded-none border-r-0 px-2.5 text-sm [&_svg]:hidden [&[data-size]]:h-8"
      >
        <SelectValue placeholder="Select..." />
      </SelectTrigger>
      <SelectContent>
        <>
          <SelectItem key={filterDef.labels.truthy} value="true">
            {filterDef.labels.truthy}
          </SelectItem>
          <SelectItem key={filterDef.labels.falsey} value="false">
            {filterDef.labels.falsey}
          </SelectItem>
        </>
      </SelectContent>
    </Select>
  );
}
